import Button from "@storeblocks/button";
import styled from "styled-components";

export const StyledButton = styled(Button)`
  height: fit-content;
  min-height: 40px;
  text-align: left;
  white-space: normal;
`;

export const ThemedButtonBase = styled(Button)`
  background: ${({ theme }) => theme.buttons.color};
  border: none;
  color: ${({ theme }) => theme.buttons.text};
  height: fit-content;
  min-height: 40px;
  text-align: left;
  white-space: normal;

  &:focus,
  &:hover {
    background: ${({ theme }) => theme.buttons.hover};
  }

  &:active {
    background: ${({ theme }) => theme.buttons.pressed};
  }
`;

export const TextButton = styled(ThemedButtonBase)`
  background: transparent;

  /* border: none; */

  /* padding: 2px; */
  color: ${({ theme }) => theme.buttons.color};

  &:focus,
  &:hover {
    background: var(--color-overlay-hover-darken);
    color: ${({ theme }) => theme.buttons.textHover};
  }
`;

export const OutlinedThemedButton = styled(ThemedButtonBase)`
  background: transparent;
  border: ${({ theme }) => theme.buttons.border};
  color: ${({ theme }) => theme.buttons.color};

  &:focus,
  &:hover {
    background: var(--color-overlay-hover-darken);
    color: ${({ theme }) => theme.buttons.textHover};
  }
`;
